import { useState, useEffect, useRef } from 'react'
import { selectCurrentId, setCredentials, selectCurrentRole } from "../authSlice"
import { useVerification2faMutation } from '../authApiSlice'
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { showSpinner, hideSpinner } from '../../../components/componentSlice'
import { useGetCrmIdByAdvisorIdMutation } from '../../crm/crmApiSlice'
import { useGetBobFormIdMutation } from '../../bob/bobApiSlice'
import { setCrm } from '../../crm/crmSlice'

const Verify2faForm = () => {
    const [code, setCode] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const id = useSelector(selectCurrentId)
    const role = useSelector(selectCurrentRole)

    const [verification2fa, { isLoading }] = useVerification2faMutation()
    const [getCrmIdByAdvisorId, { isLoading: isGetCrmLoading }] = useGetCrmIdByAdvisorIdMutation()
    const [getBobFormId, { isLoading: isGetBobFormIdLoading }] = useGetBobFormIdMutation()
    const codeInput = useRef()

    useEffect(() => {
        if(codeInput.current) {
            codeInput.current.focus()
        }
    }, [codeInput.current])

    useEffect(() => {
        if(isLoading || isGetCrmLoading || isGetBobFormIdLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading, isGetCrmLoading, isGetBobFormIdLoading])

    const onSubmit = async (e) => {
        e.preventDefault()
        setErrorMessage("")

        try {
            const response = await verification2fa({code, id})
            console.log('response', response)
            if(response?.data?.user) {
                dispatch(setCredentials(response.data?.user))
                setCode("")
                navigateAfterLogin()
            } else if(response?.error?.status === 400) {
                setErrorMessage("That code is invalid or expired. Try another.")
            }
        } catch(err) {
            console.log('erro',err)
            if(!err.status) {
                setErrorMessage("No Server Response")
            } else if(err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else if(err.status === 400 || err.status === 401) {
                setErrorMessage("That code is invalid or expired. Try another.")
            } else {
                setErrorMessage(err.data?.message)
            }
        }
    }

    const navigateAfterLogin = async () => {
        if(role === "ADVISOR") {
            try {
                const crm = await getCrmIdByAdvisorId(id).unwrap()
                console.log(crm)
                if(crm) {
                    dispatch(setCrm(crm.id))
                    navigate(`/dash/crm/${crm.id}`)
                } else {
                    navigate(`/dash/crm/${0}`)
                }
            } catch (err) {
                if(err.status == 403) {
                    navigate("/dash/error403")
                } else {
                    navigate(`/dash/crm/${0}`)
                }
            }
        }
        else if (role === "SUPPORT_STAFF") {
            navigate("/dash/support")
        } else {
            navigate("/dash")
        }
    }

    const onCancel = () => {
        navigate("/logout")
    }

    return (
        <>
            <div className='top-header'>
                <header>Verify</header>
            </div>
            <div className='verify-instruction'>
                <p>Enter the code generated by your Google Authenticator app.</p>
            </div>
            <form onSubmit={(e) => onSubmit(e)}>
                <div className='verify-input'>
                    <input required className='inpt' placeholder='Verication Code' value={code} onChange={(e) => setCode(e.target.value)} autofocus ref={codeInput} />
                </div>
                <p className='errorMessage'>{errorMessage}</p>
                <div className='verify-button-section'>
                    <button className='crm-button crm-btn-primary' type="button" onClick={() => onCancel()}>Cancel</button>
                    <button className='crm-button' type="submit">Verify</button>
                </div>
            </form>
        </>
    )
}
export default Verify2faForm